<template>
  <div class="summary-request-container">
    <a-tabs default-active-key="approve" class="centered-tabs">
      <a-tab-pane key="wait">
        <span slot="tab">
          <a-icon type="clock-circle" />
          Waiting
        </span>
        <div class="job-ads-list mt-15">
          <a-skeleton :loading="loading" active :avatar="{ size: 'large', shape: 'square' }" :paragraph="{ rows: 1 }" v-for="n in 3" :key="'skeleton-' + n" v-show="loading" />
          <div v-if="!loading">
            <div v-if="requests.wait && requests.wait.length > 0">
              <div class="job-ads-item mb-5" v-for="(req, idx) in requests.wait" :key="idx">
                <div class="job-info-with-icon">
                  <a-avatar size="large" shape="square" class="mr-10 avatar-request">
                    <a-icon :type="req.icon" />
                  </a-avatar>
                  <div class="job-info">
                    <span class="job-title">{{ req.title }}</span>
                    <span class="job-dept" v-html="req.subtitle"></span>
                  </div>
                </div>
                <div class="job-stats">
                  <div class="job-stat">
                    <a
                      v-if="req.status === 'wait'"
                      class="text-danger"
                    >
                      <a-popconfirm
                        placement="leftTop" 
                        class="font-web"
                        title="ลบคำขอ ？"
                        ok-text="ตกลงลบ"
                        @confirm="confirmDelete(req)"
                        cancel-text="ไม่ดำเนินการ"
                      >
                        <a-icon type="delete" />
                      </a-popconfirm>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <a-empty v-else :image="simpleImage" description="No waiting requests" />
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane key="approve">
        <span slot="tab">
          <a-icon type="check-circle" />
          Approved
        </span>
        <div class="job-ads-list mt-15">
          <a-skeleton :loading="loading" active :avatar="{ size: 'large', shape: 'square' }" :paragraph="{ rows: 1 }" v-for="n in 3" :key="'skeleton-' + n" v-show="loading" />
          <div v-if="!loading">
            <div v-if="requests.approve && requests.approve.length > 0">
              <div class="job-ads-item" v-for="(req, idx) in requests.approve" :key="idx">
                <div class="job-info-with-icon">
                  <a-avatar size="large" shape="square" class="mr-10 avatar-request">
                    <a-icon :type="req.icon" />
                  </a-avatar>
                  <div class="job-info">
                    <span class="job-title">{{ req.title }}</span>
                    <span class="job-dept" v-html="req.subtitle"></span>
                  </div>
                </div>
                <div class="job-stats">
                  <div class="job-stat">
                    <span class="job-stat-value text-success">{{ req.status }}</span>
                  </div>
                </div>
              </div>
            </div>
            <a-empty v-else :image="simpleImage" description="No approved requests" />
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane key="reject">
        <span slot="tab">
          <a-icon type="close-circle" />
          Rejected
        </span>
        <div class="job-ads-list mt-15">
          <a-skeleton :loading="loading" active :avatar="{ size: 'large', shape: 'square' }" :paragraph="{ rows: 1 }" v-for="n in 3" :key="'skeleton-' + n" v-show="loading" />
          <div v-if="!loading">
            <div v-if="requests.reject && requests.reject.length > 0">
              <div class="job-ads-item" v-for="(req, idx) in requests.reject" :key="idx">
                <div class="job-info-with-icon">
                  <a-avatar size="large" shape="square" class="mr-10 avatar-request">
                    <a-icon :type="req.icon" />
                  </a-avatar>
                  <div class="job-info">
                    <span class="job-title">{{ req.title }}</span>
                    <span class="job-dept" v-html="req.subtitle"></span>
                  </div>
                </div>
                <div class="job-stats">
                  <div class="job-stat">
                    <span class="job-stat-value text-error">{{ req.status }}</span>
                  </div>
                </div>
              </div>
            </div>
            <a-empty v-else :image="simpleImage" description="No rejected requests" />
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane key="cancel">
        <span slot="tab">
          <a-icon type="stop" />
          Cancelled
        </span>
        <div class="job-ads-list mt-15">
          <a-skeleton :loading="loading" active :avatar="{ size: 'large', shape: 'square' }" :paragraph="{ rows: 1 }" v-for="n in 3" :key="'skeleton-' + n" v-show="loading" />
          <div v-if="!loading">
            <div v-if="requests.cancel && requests.cancel.length > 0">
              <div class="job-ads-item" v-for="(req, idx) in requests.cancel" :key="idx">
                <div class="job-info-with-icon">
                  <a-avatar size="large" shape="square" class="mr-10 avatar-request">
                    <a-icon :type="req.icon" />
                  </a-avatar>
                  <div class="job-info">
                    <span class="job-title">{{ req.title }}</span>
                    <span class="job-dept" v-html="req.subtitle"></span>
                  </div>
                </div>
                <div class="job-stats">
                  <div class="job-stat">
                    <span class="job-stat-value text-muted">{{ req.status }}</span>
                  </div>
                </div>
              </div>
            </div>
            <a-empty v-else :image="simpleImage" description="No cancelled requests" />
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue';

export default {
  name: 'SummaryRequest',
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    requests: {
      type: Object,
      default: () => ({
        wait: [],
        approve: [],
        reject: [],
        cancel: []
      })
    }
  },
  methods: {
    getDeletePath(item) {
      const paths = {
        'leave': `/hri/leave_of_absence/${item.id}/remove/`,
        'flex': `/hri/flexible-day/${item.id}/remove/`,
        'serminar': `/hri/seminar-request/${item.id}/remove/`,
        'time': `/hri/time-request/${item.id}/remove/`,
        'home': `/hri/workfromhome/${item.id}/remove/`
      };
      return paths[item.type] || '';
    },
    confirmDelete(item) {
      const parampath = this.getDeletePath(item);
      if (parampath) {
        this.$emit('delete', parampath);
      }
    }
  }
}
</script>

<style scoped>
.summary-request-container {
  font-family: 'Inter', sans-serif;
  padding: 0 16px 16px;
}

.centered-tabs ::v-deep .ant-tabs-nav {
  width: 100%;
  display: flex;
}

.centered-tabs ::v-deep .ant-tabs-nav .ant-tabs-tab {
  flex: 1;
  text-align: center;
  margin: 0;
  padding: 12px 16px;
  transition: all 0.3s ease;
}

.job-ads-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 420px;
  overflow-y: auto;
  padding-right: 8px;
  padding-bottom: 8px;
}

/* Custom Scrollbar Styles */
.job-ads-list::-webkit-scrollbar {
  width: 6px;
}

.job-ads-list::-webkit-scrollbar-track {
  background: transparent;
}

.job-ads-list::-webkit-scrollbar-thumb {
  background: #e0e0e0;
  border-radius: 10px;
}

.job-ads-list::-webkit-scrollbar-thumb:hover {
  background: #c0c0c0;
}

.job-ads-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 12px;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.job-ads-item:hover {
  background: #ffffff;
  border-color: #e0e0e0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  transform: translateY(-1px);
}

.job-info-with-icon {
  display: flex;
  align-items: center;
}

.avatar-request {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  color: #1a1a2e;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-request i {
  font-size: 20px;
}

.job-info {
  display: flex;
  flex-direction: column;
}

.job-title {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 2px;
}

.job-dept {
  font-size: 12px;
  color: #8c8c8c;
  font-weight: 500;
  line-height: 1.4;
}

.job-dept ::v-deep b {
  color: #1a1a2e;
  font-weight: 700;
}

.job-stats {
  display: flex;
  gap: 16px;
}

.job-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 45px;
}

.job-stat-value {
  font-size: 16px;
  font-weight: 800;
}

.text-primary { color: #4285F4; }
.text-warning { color: #FBBC05; }
.text-success { color: #34A853; }
.text-error { color: #EA4335; }
.text-muted { color: #b0b0b0; }

.job-stat-label {
  font-size: 10px;
  font-weight: 600;
  color: #b0b0b0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 2px;
}

.mt-15 { margin-top: 15px; }

::v-deep .ant-tabs-ink-bar {
  height: 3px;
  border-radius: 3px 3px 0 0;
}
</style>
